module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ca":{"Amb el suport de":"Amb el suport de"},"es":{"Amb el suport de":"CON EL APOYO DE"},"en":{"Amb el suport de":"AVEC LE SOUTIEN DE"},"fr":{"Amb el suport de":"WITH THE SUPPORT"}}')
  delete Component.options._Ctor
}
